import type { FaireProductEntity } from "../../entity_types/product";

export const p_afqvreyu6f: FaireProductEntity = {
  token: "p_afqvreyu6f",
  type: "product",
  name: "Scallop Rectangular Resin Cheese Board – Green , 14 Inches",
  brandToken: "b_9f715f8d",
  brandName: "Casa Amarosa",
  imageUrl:
    "https://cdn.faire.com/fastly/34c19d0b1a918a4be755c8e9ba2100a2e7f2641f2126249020685b701a6fb131.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c84df342f5b57479287f38f172c654baf00b46f2179f8ef731cb983e184766e6.png",
    "https://cdn.faire.com/fastly/f4d06276aca2adafe6bb3b0765d34f0707511343e4e4c378758d7ddf5529ecf1.jpeg",
    "https://cdn.faire.com/fastly/019290dbe21ea87060758829e9fe5b5ad48bda90d4130a426667cd59e105ee34.jpeg",
  ],
  priceDollars: 45,
  description:
    "Make your tablescape pop with this dazzling Green resin cheese board! With bold swirls and wavy edges, ideal for cheese, snacks, or sweets.",
  tags: [],
  isBestseller: true,
  msrpDollars: 90,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-06T00:00:00.000Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
